export default {
  state: {
    lyft: {
      enabled: false, // use by future RSVP
      enabledLeg2: false, // use by future RSVP - leg2
      show: false, // use by ASAP
      rsvps: []
    }
  },
  mutations: {
    setLyftData (state, data) {
      for (let field in data) {
        state.lyft[field] = data[field]
      }
    },
    addLyftRsvp (state, val) {
      state.lyft.rsvps.push(val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/lyft.js